const Shopify = require('shopify-api-node');

// Replace the values in angle brackets with your store information and API credentials
const shopify = new Shopify({
  shopName: '<black-slate-home>',
  apiKey: '<63d89be74dfaef9f2a25b599391f4040>',
  password: '<bf4797413c80580206523752cb3417c6>'
});

// Set the discount amount and percentage here
const discountAmount = 5;
const discountPercentage = 10;

// Set the minimum order amount to qualify for the discount
const minOrderAmount = 50;

// Create the discount code
const discountCode = {
  code: 'PREPAID5',
  discount_type: 'fixed_amount',
  value: discountAmount,
  applies_to_resource: {
    type: 'Order',
    minimum_subtotal: minOrderAmount
  },
  usage_limit: 1,
  customer_selection: 'all',
  applies_once: true,
  applies_to_id: null,
  applies_to_value: 'prepaid'
};

// Create the discount percentage
const discountPercentageCode = {
  code: 'PREPAID10',
  discount_type: 'percentage',
  value: discountPercentage,
  applies_to_resource: {
    type: 'Order',
    minimum_subtotal: minOrderAmount
  },
  usage_limit: 1,
  customer_selection: 'all',
  applies_once: true,
  applies_to_id: null,
  applies_to_value: 'prepaid'
};

// Create the discounts in Shopify
async function createDiscounts() {
  try {
    const discount = await shopify.discount.create(discountCode);
    console.log(discount);
    const discountPercentage = await shopify.discount.create(discountPercentageCode);
    console.log(discountPercentage);
  } catch (err) {
    console.log(err);
  }
}

createDiscounts();
